import React, { useRef } from "react";
import TextInput from "./text-input";

interface CurrencyInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  onCommit?: (value: number | null) => void;
  inputClassName?: string;
}

const MAX_NUMBER = 100000000

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  onCommit,
  inputClassName,
  ...props
}) => {
  const ref = useRef<HTMLInputElement>(null);

  const format = (v: number) =>
    v == null || Number.isNaN(v) ? "" : `$${v}`;

  const handleFocus = () => {
    if (!ref.current) return;
    ref.current.value = ref.current.value.replace(/[^0-9.]/g, "");
  };

  const handleBlur = () => {
    if (!ref.current) return;

    const raw = ref.current.value.replace(/[^0-9.]/g, "");
    let value = raw === "" ? 0 : parseFloat(raw);
    if (Number.isNaN(value)) value = 0;
    if (value > MAX_NUMBER) value = MAX_NUMBER;

    onCommit?.(value);
    ref.current.value = format(value);
  };

  return (
    <TextInput
      {...props}
      inputClassName={inputClassName}
      ref={ref}
      type="text"
      inputMode="decimal"
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
};

export default CurrencyInput;
